export default "__VITE_ASSET__CS2qXdfL__"